import { ReactNode } from "react";
import { FooterUI } from "@/components/Footer/FooterUI";
import { HeaderUI } from "@/components/Header/HeaderUI";

type Props = {
  children?: ReactNode | undefined;
};

export function HeaderAndFooter({ children }: Props) {
  return (
    <>
      <HeaderUI srcUrl="/scaffold/header.html?includeCoreCSS=false&includeCoreJS=false&includePolyfills=false" />
      {children}
      <FooterUI srcUrl="/esi/footer" />
    </>
  );
}
